import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Join from './Join';

import head from '../../components/Meta';
import config from '../../../config';

// eslint-disable-next-line
import styles from './join.scss';

class JoinPage extends Component {
    constructor(props) {
        super(props);
        if (props.auth && props.auth.user) {
            props.history.replace('/home'); // Go to dashboard if logged in
        }
    }

    render() {
        /*
        const parsed = queryString.parse(this.props.location.search);
        const { return: returnUrl, flow } = parsed;
        let redirectUrl = `/onboarding${Object.keys(parsed).length > 0 ? '?' + queryString.stringify(parsed, { encode: false }) : ''}`;
        /*
        if(flow === 'club_create') {
            redirectUrl = returnUrl;
        } */
        /*
        console.log(redirectUrl);
        var googleAppId = '1096102074087-nl1n118e9ke8b1uip5fa6b1rsh13t0el.apps.googleusercontent.com';
        var gRedirectUri = `${config.appHost}/signin-google`;
        var appId = '1701644616548664';
        var fbRedirectUri = `${config.appHost}/signin-facebook`;
        var stateParam = Buffer.from(`{"sourcePath": "${parsed.source || '/dashboard'}"}`).toString('base64');
        var facebookUrl = `https://www.facebook.com/v2.12/dialog/oauth?
        client_id=${appId}
        &redirect_uri=${fbRedirectUri}
        &state=${stateParam}
        &response_type=token&scope=email`;
        var googleUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${googleAppId}&redirect_uri=${gRedirectUri}&response_type=code&scope=openid email profile&state=${stateParam}`
        const loginParsed = parsed;
        if(returnUrl) {
            loginParsed.next = returnUrl;
            delete loginParsed.return;
        }
        return(
            <div className={styles.section}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 offset-md-3">
                            <div className={`${styles.title}`}>
                                <span>
                                    Welcome to the world’s fastest-growing tennis community!
                                </span>
                            </div>
                            <div className={styles.accentTitle}>
                                <span>Get rated, create your profile and start finding players & events</span>
                            </div>
                            <a className={`btn btn-social btn-social-fb btn-xl ${styles.joinBtnFacebook}`} href={facebookUrl}>
                                <img src="/img/social/facebook-icon.svg"></img>CONTINUE WITH FACEBOOK
                            </a>

                            <hr className="hr-text" data-content="or"></hr>
                            <CreateAccount onSubmit={this.submit} redirectUrl={redirectUrl}/>
                            <div className={styles.tos}>
                                <span>By continuing, I agree to the <a href={config.appHost + '/tos'} target="_blank">terms of service</a>.</span>
                            </div>
                            <div className={styles.divider} />
                            <p>Already have an account? <Link to={`/login${Object.keys(loginParsed).length > 0 ? '?' + queryString.stringify(loginParsed, { encode: false }) : ''}`}>Sign in <i className="fas fa-long-arrow-alt-right bounce-right"></i></Link></p>
                        </div>
                    </div>
                </div>
            </div> */

        return (
            <div>
                {head({
                    title: `Sign Up | UTR Sports`,
                    image: `https://www.${config.siteBaseUrl}/img/utr_sports/utr-sports-logo.svg`,
                    imageWidth: '930',
                    imageHeight: '395',
                })}
                <Join
                    {...this.props}
                />
            </div>

        );
    }
}

export default withRouter(JoinPage);
